import React, { useEffect, useRef, useState } from 'react';
import FooterButton from '../FooterButton';
import { createDriverApi, getDriverDetailsAPI } from '../../utils/apiServices'
import { useLocation, useNavigate } from 'react-router-dom';
import { ErrorModal, SuccessModal } from '../FormComponents';
import { AUTH_CODE, path_Operation } from '../../constants/constVariables';
import BackButton from '../../clientComponents/BackButton/BackButton';
import { CustomTab } from '../../atomicComponents';
import { useAuthorizationContext } from '../../providers/AuthorizationHandler/AuthorizationHandler';
import { Regex } from '../../constants/contants'
import { getPlantValue, postUsageAnalyticsCall } from '../../constants/Utils';
import styles from "./AddNewDriver.module.css";
import Loader from '../Loader';

export default function AddNewDriver() {
    const { user } = useAuthorizationContext();

    const location = useLocation();
    const navigate = useNavigate();

    const DriverFNameRef = useRef("");
    const DriverLNameRef = useRef("");
    const DriverNumberRef = useRef("");
    const ContractorNameRef = useRef("");
    const ContractorNumberRef = useRef("");

    const [driverData, setDriverData] = useState();
    const [loader, setLoader] = useState(false);
    const [isModalOpen, setModalIsOpen] = useState(false);
    const [isErrorModalOpen, setErrorModalIsOpen] = useState(false);
    const [title, setTitle] = useState("");
    const [pageLeaveTime, setPageLeaveTime] = useState();

    const filterPlantName = getPlantValue();

    const check = async () => {
        if (location?.state?.edit) {
            fetchDriverDetails()
        } else {
            setLoader(true)
        }
    }
    const fetchDriverDetails = async () => {
        await getDriverDetailsAPI(location?.state?.data?.driver_id).then((response) => {
            setDriverData(response?.data?.data[0])
            setLoader(true);
        })
    }

    useEffect(() => {
        if (loader) {
            DriverFNameRef.current.value = driverData?.first_name
            DriverNumberRef.current.value = driverData?.driver_mobile_no
            DriverLNameRef.current.value = driverData?.last_name
            ContractorNameRef.current.value = driverData?.contracter_name
            ContractorNumberRef.current.value = driverData?.contracter_mobile_no
        }
    }, [loader])
    useEffect(() => {
        check();
        setPageLeaveTime(new Date())
    }, [])
    useEffect(() => {
        return () => {
            if (new Date() - pageLeaveTime) {
                const a = path_Operation?.filter((d, i) => {
                    return d?.name == location?.pathname
                })
                postUsageAnalyticsCall(user?.name, user?.userID, a[0]?.pageName ? a[0]?.pageName : location?.pathname, pageLeaveTime, a[0]?.operation ? a[0]?.operation : 'view', (new Date() - pageLeaveTime))
            }
        }
    }, [pageLeaveTime])
    const PinReset = (props) => {
        // console.log(props.pin)
        return (
            <div className={styles.reset_pin_container}>
                <div className={styles.reset_pin_container_heading}>Your Pin</div>
                <div className={styles.reset_pin_container_pin}>{props.pin}</div>
            </div>
        )
    }
    async function createDriverFn() {
        // console.log("inside create driver")

        const payload = {
            plant_id: filterPlantName.value,
            first_name: DriverFNameRef.current.value,
            last_name: DriverLNameRef.current.value,
            driver_mobile_no: DriverNumberRef.current.value,
            contracter_name: ContractorNameRef.current.value,
            contracter_mobile_no: ContractorNumberRef.current.value,
            created_by: user?.name,
            created_by_id: user?.userID,
            operation: 'add',
        };
        // if (zoneNameRef.current.value !== "" && areaRef.current.value !== "") {
        // console.log("Create Driver Payload = ", payload)
        const response = await createDriverApi(payload)
            .then((res) => {
                // console.log(res.data);
                if (res.status == 201) {
                    setTitle(<PinReset pin={res?.data?.data[0]?.password} />);
                    setModalIsOpen(true);
                    // console.log("fdffdfd = ", location?.pathname)
                    const a = path_Operation?.filter((d, i) => {
                        return d?.name == "create-driver"
                    })
                    // console.log("A = ", a[0]?.operation)
                    postUsageAnalyticsCall(user?.name, user?.userID, a[0]?.pageName ? a[0]?.pageName : "create-driver", new Date(), a[0]?.operation ? a[0]?.operation : 'view', 0)
                }
            })
            .catch((error) => {
                // console.log(error);
                setTitle(error?.response?.data?.message);
                setErrorModalIsOpen(true);
            });
        // } else {
        //     setErrorModalIsOpen(true);
        // }
    }
    function validation(e, id, type, msg) {
        // console.log("check called", e.target.value, id, type)
        var errorMsg = document.getElementById(id)
        if (type === 'number') {
            if (Regex.phone.test(e.target.value)) {
                // console.log("pass")
                errorMsg.innerHTML = ''
                // return false
            }
            else {
                errorMsg.innerHTML = msg;
                buttonToggle("disabled");
                return false
            }
        }
        else if (type === 'text') {
            if (e.target.value.length > 1) {
                if (!Regex.first_name.test(e.target.value)) {
                    errorMsg.innerHTML = 'Special characters not be allowed';
                }
                else {
                    // console.log("txt pass")
                    errorMsg.innerHTML = '';
                    // return false
                }
            }
            else {
                errorMsg.innerHTML = msg;
                buttonToggle("disabled");
                return false
            }
        }
        else {
            if (e.target.value.length < 1) {
                errorMsg.innerHTML = msg
            }
            else {
                errorMsg.innerHTML = ''
            }
        }
        // console.log("caleddddddddddddddddddddd", DriverFNameRef.current.value, DriverLNameRef.current.value, DriverNumberRef.current.value, ContractorNumberRef.current.value, ContractorNameRef.current.value)
        if (
            DriverFNameRef.current.value.length > 1 && Regex.first_name.test(DriverFNameRef.current.value) &&
            DriverLNameRef.current.value.length > 1 && Regex.first_name.test(DriverLNameRef.current.value) &&
            Regex.phone.test(DriverNumberRef.current.value) &&
            Regex.phone.test(ContractorNumberRef.current.value) &&
            ContractorNameRef.current.value.length > 1
        ) {
            // console.log('inside')
            buttonToggle("enabled");
        }
        else {
            buttonToggle("disabled");
        }
    }
    const editDriverFn = async () => {
        const payload = {
            driver_id: driverData.driver_id,
            plant_id: filterPlantName.value,
            first_name: DriverFNameRef.current.value,
            last_name: DriverLNameRef.current.value,
            driver_mobile_no: DriverNumberRef.current.value,
            contracter_name: ContractorNameRef.current.value,
            contracter_mobile_no: ContractorNumberRef.current.value,
            updated_by: user?.name,
            updated_by_id: user?.userID,
            operation: '',
        };
        // console.log("payload of edit driver = ", payload)
        const response = await createDriverApi(payload)
            .then((res) => {
                // console.log(res.data.message);
                if (res.status == 200) {
                    setTitle(res.data.message);
                    setModalIsOpen(true);
                    // console.log("fdffdfd = ", location?.pathname)
                    const a = path_Operation?.filter((d, i) => {
                        return d?.name == "edit-driver"
                    })
                    // console.log("A = ", a[0]?.operation)
                    postUsageAnalyticsCall(user?.name, user?.userID, a[0]?.pageName ? a[0]?.pageName : "edit-driver", new Date(), a[0]?.operation ? a[0]?.operation : 'view', 0)
                }
            })
            .catch((error) => {
                // console.log(error);
                setTitle(error?.response?.data?.message);
                setErrorModalIsOpen(true);
            });
    };
    const handleButton = () => {
        if (location?.state?.edit) {
            //console.log("EDIT");
            buttonToggle("disabled")
            editDriverFn();
        } else {
            //console.log("CREATE");
            buttonToggle("disabled")
            createDriverFn();
        }
    }

    const buttonToggle = (value) => {
        if (value === "enabled") {
            const button = document.getElementById("SUBMIT");
            button.disabled = false;
            button.classList.remove("button-disabled");
            button.classList.add("button-enabled");
            button.style.cursor = "pointer";
        }
        else {
            const button = document.getElementById("SUBMIT")
            button.classList.remove("button-enabled");
            button.classList.add("button-disabled")
            button.style.cursor = "unset"
            button.disabled = true;
        }
    };
    return (
        <>
            {
                loader ?
                    <>
                        <div className='breadcrumb'>
                            <BackButton basePath={"driver master"} action={location?.state?.edit ? "edit driver" : "add new driver"} handleClick={() => { navigate(-1); }} />
                        </div>
                        <div className="headerwithcount">
                            <div className='countdiv'>
                                <CustomTab
                                    isSelected={false}
                                    withOutCount
                                    title={location?.state?.edit ? "Edit Driver" : "Add New Driver"}
                                />
                            </div>
                            <div className="blankdiv">
                                <span className='vin-search-head-container'>{location?.state?.edit ? null : "Note: Make sure all mandatory fields are filled."}</span>
                            </div>
                        </div>
                        <div className={styles.driverContainer}>
                            <div className={styles.driverParent}>
                                <div className={styles.driverTabContainer}>
                                    <div className={styles.tabHeading}>Driver Details</div>
                                </div>
                                <div className={styles.tabContainer} >
                                    <div className="zone-header-data-container" style={{ paddingBottom: '1rem' }} >
                                        <span className="zone-header area-header" style={{ width: 'auto' }}>First Name*</span>
                                        <div className='errorMessage_container' style={{ width: '100%', }}>
                                            <input className='zone-input-fild regularFont' type='text' min="0" maxlength="30" ref={DriverFNameRef}
                                                onInput={(e) => {
                                                    DriverFNameRef.current.value = DriverFNameRef.current.value.replace(/[&\/\\#,+()$~%.'":*?<>{} ]/g, '');
                                                }}
                                                onChange={(e) => validation(e, 'nameError_fname', 'text', 'Invalid First Name')} />
                                            <span id={'nameError_fname'} className='title' style={{ position: 'absolute', bottom: '0' }}></span>
                                        </div>
                                    </div>
                                    <div className="zone-header-data-container" style={{ paddingBottom: '1rem' }} >
                                        <span className="zone-header area-header" style={{ width: 'auto' }}>Driver Number*</span>
                                        <div className='errorMessage_container' style={{ width: '100%', }}>
                                            <input className='zone-input-fild regularFont' type='text' min="0" maxlength="10" ref={DriverNumberRef}
                                                onInput={(e) => {
                                                    DriverNumberRef.current.value = DriverNumberRef.current.value.replace(/[&\/\\#,+()$~%.'";:*?<>{}_^@! ]/g, '');
                                                }}
                                                onChange={(e) => validation(e, 'nameError_dnumber', 'number', 'Invalid Mobile Number')} />
                                            <span id={'nameError_dnumber'} className='title' style={{ position: 'absolute', bottom: '0' }}></span>
                                        </div>
                                    </div>
                                    <div className="zone-header-data-container" style={{ paddingBottom: '1rem' }} >
                                        <span className="zone-header area-header" style={{ width: 'auto' }}>Last Name*</span>
                                        <div className='errorMessage_container' style={{ width: '100%', }}>
                                            <input className='zone-input-fild regularFont' type='text' min="0" maxlength="30" ref={DriverLNameRef}
                                                onInput={(e) => {
                                                    DriverLNameRef.current.value = DriverLNameRef.current.value.replace(/[&\/\\#,+()$~%.'":*?<>{} ]/g, '');
                                                }}
                                                onChange={(e) => validation(e, 'nameError_lname', 'text', 'Invalid First Name')} />
                                            <span id={'nameError_lname'} className='title' style={{ position: 'absolute', bottom: '0' }}></span>
                                        </div>
                                    </div>
                                </div>

                                <div className={styles.driverTabContainer}>
                                    <div className={styles.tabHeading}>Contractor Details</div>
                                </div>
                                <div className={styles.tabContainer} >
                                    <div className="zone-header-data-container" style={{ paddingBottom: '1rem' }} >
                                        <span className="zone-header area-header" style={{ width: 'auto' }}>Name*</span>
                                        <div className='errorMessage_container' style={{ width: '100%', }}>
                                            <input className='zone-input-fild regularFont' type='text' min="0" maxlength="30" ref={ContractorNameRef} onChange={(e) => validation(e, 'nameError_cname', 'cName', "Invalid Name")} />
                                            <span id={'nameError_cname'} className='title' style={{ position: 'absolute', bottom: '0' }}></span>
                                        </div>
                                    </div>
                                    <div className="zone-header-data-container" style={{ paddingBottom: '1rem' }} >
                                        <span className="zone-header area-header" style={{ width: 'auto' }}>Contractor Number*</span>
                                        <div className='errorMessage_container' style={{ width: '100%', }}>
                                            <input className='zone-input-fild regularFont' type='text' min="0" maxlength="10" ref={ContractorNumberRef}
                                                onInput={(e) => {
                                                    ContractorNumberRef.current.value = ContractorNumberRef.current.value.replace(/[&\/\\#,+()$~%.'":*?<>{} ]/g, '');
                                                }}
                                                onChange={(e) => validation(e, 'nameError_cnumber', 'number', "Invalid Contractor Number")} />
                                            <span id={'nameError_cnumber'} className='title' style={{ position: 'absolute', bottom: '0' }}></span>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="horizontal-line" style={{ marginTop: "1rem" }}></div>
                        <div className="vin-details-footer" style={{ flexDirection: "row-reverse" }}>
                            <FooterButton shouldEnable={false} value="SUBMIT" backgroundColor="#82C1A7" secondaryColor="#488f71" handle={handleButton} authOperation={AUTH_CODE.CREATE} />
                        </div>
                        {<SuccessModal open={isModalOpen} handleClose={() => navigate("/driver-master")} title={''} render_title={title} />}
                        {<ErrorModal open={isErrorModalOpen} handleClose={() => setErrorModalIsOpen(false)} title={title} />}
                    </>
                    :
                    <div style={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <Loader />
                    </div>
            }
        </>
    )
}
